import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2028"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "7.606",
  cy: "12.063",
  r: ".712"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M7.606 6.88a.885.885 0 0 0-.876 1.007l.393 2.817h.965l.394-2.817a.884.884 0 0 0-.876-1.007z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "m13.797 9.03-.738.738a1.896 1.896 0 0 1 1.185 1.755 1.898 1.898 0 0 1-1.896 1.896H4.042a2.903 2.903 0 0 1-2.899-2.9A2.902 2.902 0 0 1 4.042 7.62l.497.038.145-.308a3.497 3.497 0 0 1 3.154-2.013c1.325 0 2.465.752 3.054 1.844l.73-.73c-.794-1.263-2.185-2.113-3.784-2.113a4.504 4.504 0 0 0-3.903 2.283 3.905 3.905 0 0 0-3.792 3.898c0 2.15 1.749 3.9 3.899 3.9h8.307a2.9 2.9 0 0 0 2.896-2.896 2.889 2.889 0 0 0-1.448-2.493zm1.822-2.825L14.244 4.83a.457.457 0 0 0-.647 0l-.339.339 2.023 2.023.339-.339a.459.459 0 0 0-.001-.648z" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", { d: "m9.452 10.997 2.763-.74-2.023-2.023zm5.673-3.65-2.023-2.023-2.734 2.734 2.023 2.023 2.734-2.734zM11.52 8.583l2.106-2.106.347.346-2.107 2.107-.346-.347z" }, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }